import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Phase.module.css';
import { DBRadioButton } from '_components';


class PatientCareCenterNoteSubjectivePhase extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='sub_phase' name='Phase' level={1} className={this.props.isWc ? styles.required : ''}>
                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBPHASE'
                        label='0-7 days'
                        selectedValue='0-7 days'
                        className={styles.col2}
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBPHASE'
                        label='8-14 days'
                        selectedValue='8-14 days'
                        className={styles.col2}
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBPHASE'
                        label='15-21 days'
                        selectedValue='15-21 days'
                        className={styles.col2}
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBPHASE'
                        label='22-90 days'
                        selectedValue='22-90 days'
                        className={styles.col2}
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBPHASE'
                        label='91 days - 6 months'
                        selectedValue='91 days - 6 months'
                        className={styles.col2}
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBPHASE'
                        label='Over 6 months'
                        selectedValue='Over 6 months'
                        className={styles.col2}
                    />
                </div>


            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);
    let isWc = state.entities.admissions[state.entities.notes.PTEVAL[evno].EVEPNO].isWc;

    return {
        noteId: noteId,
        evno: evno,
        isWc
    };
}


const connectedPatientCareCenterNoteSubjectivePhase = connect(mapStateToProps)(PatientCareCenterNoteSubjectivePhase);
export { connectedPatientCareCenterNoteSubjectivePhase as PatientCareCenterNoteSubjectivePhase };

